<template>
  <div story>
    <div class="wrapper">
      <top-visual type="board">
        <h2>EVENT</h2>
        <h3>가인패드만의 특별한 이벤트에 참여해보세요</h3>
      </top-visual>
      <section class="detail" v-if="detailData" :key="detailData.SQ">
        <p class="ttl">{{ detailData.TITLE }}</p>
        <div class="cont">
          <img :src="`/static/uploaded/${detailData.IMG}`" alt="">
          <p class="sttl" v-html="contParse(detailData.SUB)"></p>
          <div v-html="contParse(detailData.CONT)"></div>
        </div>
        <div class="other hidden-lg-up">
          <router-link class="prev" v-if="prevData" :to="`/board/event/${prevData.SQ}`">{{ prevData.TITLE }}</router-link>
          <router-link class="next" v-if="nextData" :to="`/board/event/${nextData.SQ}`">{{ nextData.TITLE }}</router-link>
        </div>
        <div class="btn-wrap">
          <router-link to="/board/event" class="btn-list">목 록</router-link>
        </div>
      </section>
      <div class="other-l hidden-md-down">
        <router-link v-if="prevData" :to="`/board/event/${prevData.SQ}`" :style="`background-image: url('/static/uploaded/${prevData.IMG}`">
          <div>
            <p>{{ prevData.TITLE }}</p>
            <p class="prev">PREV</p>
          </div>
        </router-link>
        <a v-else>
          <div>
            <p>이전항목이 없습니다</p>
          </div>
        </a>
        <router-link v-if="nextData" :to="`/board/event/${nextData.SQ}`" :style="`background-image: url('/static/uploaded/${nextData.IMG}`">
          <div>
            <p>{{ nextData.TITLE }}</p>
            <p class="next">NEXT</p>
          </div>
        </router-link>
        <a v-else>
          <div>
            <p>다음항목이 없습니다</p>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  @import "../less/gynpad";
  @import "../less/asset";
  [story] { .rel; overflow:hidden; }

  .detail { padding:0 30px;
    .ttl { .rm-t(50); .fs(1.5rem); .bold; .tc; }
    .cont { .rp-v(20);
      img { .block; margin-bottom:25px; max-width:100%; }
      .sttl { margin:25px 0 10px; .fs(1.25rem); }
    }
    .other { .border-v(#ededed); padding:15px 0;
      a { .block; height:24px; margin:5px 0; padding-left:35px; .fsl(1.16rem,24px,500); background: left center no-repeat; background-size:24px 24px;
        &.prev { background-image:url('@{story}/page-arr-prev.s.png'); }
        &.next { background-image:url('@{story}/page-arr-next.s.png'); }
      }
    }
    .btn-list { .block; margin:15px 0; .wh(95px,35px); color:#fff; background:#f85c70; .tc; line-height:35px; .m-hc; }
  }

  @media (min-width: @screen-lg-min) {
    [story] { padding-bottom:130px; }

    .detail { padding:0; width:980px; .m-hc;
      .ttl { margin-top:80px; .fs(40px); }
      .cont { padding:50px 0; .border-b(#d6d6d6); .fsl(18px,1.5);
        img { .block; margin-bottom:25px; max-width:100%; }
        .sttl { margin:70px 0 30px; .fs(30px); }
      }
      .btn-wrap { .tr;
        .btn-list { .ib; margin:20px 0; .wh(160px,50px); .fsl(18px,50px); }
      }
    }
    .other-l { .cf; margin-top:80px;
      a { .tbl; .fl; width:50%; background:#666 center no-repeat; background-size:cover;
        > div { .cell; .vam; .tc; height:205px; background:rgba(0,0,0,0.4);
          p { .fs(30px); color:#fff; }
          p + p { .ib; height:23px; padding:0 26px; .fs(20px);
            &.prev { background:url("@{story}/arr-l.svg") left 3px no-repeat; }
            &.next { background:url("@{story}/arr-r.svg") right 3px no-repeat; }
          }
        }
      }
    }
  }

</style>

<script>
import axios from 'axios';
import handler from '../util/ErrorHandler';
import TopVisual from '../components/TopVisual.vue';
import { contParse } from '../util';

export default {
  name: 'EventDetail',
  components: { TopVisual },
  data() {
    return {
      detailData: null,
      prevData: null,
      nextData: null,
    };
  },
  watch: {
    $route() {
      this.getData();
    },
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      axios.get('/api/board/detail', { params: { SQ: this.$route.params.detail, TYPE: 'EVENT' } })
        .then(({ data }) => {
          this.detailData = data.detail;
          this.prevData = data.prev;
          this.nextData = data.next;
        })
        .catch(handler());
    },
    contParse(org) {
      return contParse(org);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/EventDetail.vue